// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__DnNKO","search":"Settings_search__34muT","filter":"Settings_filter__7F9gV"};